import { X } from "lucide-react";
import React from "react";

export default function SideDrawer({ title, isOpen, onClose, children, closeOnOverlay = false }) {
  return (
    <>
      {/* Overlay */}
      {isOpen && <div className="side-drawer-overlay" onClick={closeOnOverlay ? onClose : undefined}  />}

      {/* Drawer */}
      <div className={`side-drawer ${isOpen ? "open" : ""}`}>
        <div className="drawer-header">
          <h2 className="drawer-title">{title}</h2>
          <button className="close-btn" onClick={onClose}>
            <X size={24} />
          </button>
        </div>

        <div className="drawer-content">{children}</div>
      </div>
    </>
  );
}